// Shared constants + small components for the public site.

// Direct FiveM connect link (cfx join code for MWRP).
export const CONNECT_URL = 'https://cfx.re/join/3pa63r'

export function DiscordIcon({ className }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
    </svg>
  )
}

// Cinematic banner at the top of inner pages (store, rules, legal). Sits under
// the fixed transparent header, so it carries its own top padding.
export function PageBanner({ image, title, children, aside }) {
  return (
    <section className="relative overflow-hidden mw-grain">
      {image && (
        <div className="absolute inset-0 overflow-hidden">
          <img src={image} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-55 mw-kb" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#07080b] via-[#07080b]/80 to-[#07080b]/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#07080b] via-transparent to-[#07080b]/70" />
        </div>
      )}
      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10 pt-36 pb-12 sm:pt-44 sm:pb-16 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <div className="max-w-3xl">
          <h1 className="mw-display mw-rise text-white text-[64px] sm:text-[96px] lg:text-[112px]">{title}</h1>
          {children && (
            <div className="mw-rise mt-5 text-[16px] sm:text-[17px] text-[#a6a8ae] leading-relaxed max-w-xl" style={{ '--mw-delay': '120ms' }}>
              {children}
            </div>
          )}
        </div>
        {aside && <div className="mw-rise lg:pb-2" style={{ '--mw-delay': '200ms' }}>{aside}</div>}
      </div>
    </section>
  )
}
